import { render, staticRenderFns } from "./AOwnerDetailAppUser.vue?vue&type=template&id=4229914b&scoped=true"
import script from "./AOwnerDetailAppUser.vue?vue&type=script&lang=js"
export * from "./AOwnerDetailAppUser.vue?vue&type=script&lang=js"
import style0 from "./AOwnerDetailAppUser.vue?vue&type=style&index=0&id=4229914b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4229914b",
  null
  
)

export default component.exports